<div class="detail-map show" [id]="mapId"></div>
